export default __webpack_public_path__ + "static/media/Audio-Player.3d4df11d.png";